<template>
  <div class="allMessage">
    <div class="allMessageBox">
      <div
        v-for="(item, index) in allMessageList"
        :key="index"
        class="allMessage_list"
      >
        <div class="allMessage_img_box">
          <img :src="item.icon" alt="" class="allMessage_img" />
        </div>
        <div class="">
          <p class="allMessage_box">
            <span class="allMessage_box_nums">{{ item.nums }}</span>
            <span class="allMessage_box_dan">个</span>
          </p>
          <p class="allMessage_box_name">{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {findAllCount, findTransCount} from "../../utils/interface";
export default {
  name: "allMessage",
  data() {
    return {
      allMessageList: [
        {
          icon: require("../../assets/home/user.png"),
          nums: "0",
          name: "用户数",
        },
        {
          icon: require("../../assets/home/emp.png"),
          nums: "0",
          name: "企业数",
        },
        {
          icon: require("../../assets/home/server.png"),
          nums: "104",
          name: "设备连接数",
        },

        {
          icon: require("../../assets/home/numbers.png"),
          nums: "10",
          name: "赋码数",
        },
        {
          icon: require("../../assets/home/apps.png"),
          nums: "0",
          name: "软件数",
        },
      ],
    };
  },
  created() {
    this.findAllCount();
  },
  methods: {
    findAllCount() {
      findAllCount().then(res => {
        console.log(1111, res)
        this.allMessageList[0].nums = res.data.userCount+439;
        this.allMessageList[1].nums = res.data.enterpriseCount;
        this.allMessageList[4].nums = res.data.softwareCount;
      })
      findTransCount().then(res => {
        this.allMessageList[3].nums = res;
      })

    },
  },
};
</script>
<style scoped lang="less">
.allMessage {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../../assets/home/12BJ.png") no-repeat;
  background-size: 100% 100%;
  height: 200px;
  .allMessageBox {
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .allMessage_list {
    display: flex;
    align-items: center;
    .allMessage_img_box {
      border-radius: 50%;
      width: 80px;
      height: 80px;
      line-height: 120px;
      text-align: center;
      margin-right: 13px;
      .allMessage_img {
        width: 80px;
        height: 80px;
      }
    }
    .allMessage_box {
      display: flex;
      align-items: baseline;
      font-size: 14px;
      .allMessage_box_nums {
        font-size: 32px;
        font-family: ABCMarfa-Bold, ABCMarfa;
        font-weight: bold;
        color: #009999;
        margin-right: 15px;
      }
    }
    .allMessage_box_name {
      font-size: 14px;
      color: #6e6e6e;
      margin-top: 12px;
      margin-left: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/homeIndex/allMessage.vue